import { connect } from "react-redux";
import { mapProps } from "recompose";
import { injectIntl } from "react-intl";
import { compose } from "cxa-utils";
import ClaimAccountStatement from "./ClaimAccountStatement";
import messages from "../messagesDescription";
import { loadAccounts } from "../../actions/claimActions";

const {
  NumDescription,
  transactionDescription,
  categoryDescription,
  transactedOnDescription,
  effectiveOnDescription,
  amountDescription,
} = messages;

// NOTE:
// - those 2 functions(getAccountsByPeroid, getAccountByConditions) need to be placed somewhere
// - will move it after checking another components

/**
 * Get accounts by period
 * @param  {number} period
 * @return {Array}
 */
const getAccountsByPeroid = period => accounts => {
  return accounts.byId[period] || [];
};

/**
 * Get account by multiple conditions
 * @param  {Object}  conditions
 * @param  {string}  conditions.accountType
 * @param  {string}  conditions.memberId
 * @param  {string}  conditions.planPeriodEnd
 * @return {Object?}
 */
const getAccountByConditions = ({ accountType, memberId, memberType, planPeriodEnd }) => filteredAccount => {
  memberId = Number.parseInt(memberId, 10);
  return filteredAccount.find(
    item =>
      item.accountType == accountType &&
      item.memberId == memberId &&
      (item.memberType == memberType || !memberType) &&
      item.periodEnd == planPeriodEnd
  );
};

const mapStateToProps = ({ claims, login }, ownProps) => {
  const { accounts } = claims;
  const { error, isFetched, pageFields,uiConfigs } = accounts;
  const { user } = login;
  const { employee } = user;
  const { objectId: employeeId } = employee;
  const { match, query } = ownProps;
  const { params } = match;
  const { benefitPeriod, accountType, benefitPeriodEnd = "" } = params;
  const { memberId = employeeId, memberType } = query;
  const decodedPeriodEnd = decodeURIComponent(benefitPeriodEnd);
  const planPeriodEnd = decodedPeriodEnd || benefitPeriodEnd;
  const account =
    compose(
      getAccountByConditions({ accountType, memberId, memberType, planPeriodEnd }),
      getAccountsByPeroid(benefitPeriod)
    )(accounts) || {};
  const { transactions = [] } = account;
  const rows = transactions.map((transaction, idx) => ({
    ...transaction,
    incrementalID: idx + 1,
  }));

  return {
    benefitPeriodEnd: decodedPeriodEnd,
    isFetched,
    error,
    user,
    rows,
    benefitPeriod,
    accountType,
    account,
    pageFields,
    uiConfigs
  };
};

const mapDispatchToProps = {
  loadAccounts,
};

// NOTE:
// - currently, no columns data
// - need intl to create columns header
const mergeProps = ({ intl, columns, ...props }) => {
  columns = columns || [
    {
      displayLabel: intl.formatMessage(NumDescription),
      fieldID: "incrementalID",
      shouldDisplay: true,
      isIntlSkipped: true,
    },
    {
      displayLabel: intl.formatMessage(transactionDescription),
      fieldID: "reference",
      shouldDisplay: true,
      format: "${'@transactionDesc(transactionType, reference)'}",
    },
    {
      displayLabel: intl.formatMessage(categoryDescription),
      fieldID: "transactionType",
      shouldDisplay: true,
    },
    {
      displayLabel: intl.formatMessage(transactedOnDescription),
      fieldID: "transactionDate",
      shouldDisplay: true,
      format: "${ '@date(transactionDate)'}",
    },
    {
      displayLabel: intl.formatMessage(effectiveOnDescription),
      fieldID: "effectiveDate",
      shouldDisplay: true,
      format: "${ '@date(effectiveDate)'}",
    },
    {
      displayLabel: intl.formatMessage(amountDescription),
      fieldID: "actualAmount",
      shouldDisplay: true,
      format: "${'@currency(actualAmount)'}",
    },
  ];

  return {
    ...props,
    intl,
    columns,
  };
};

const ClaimAccountStatementContainer = compose(
  injectIntl,
  mapProps(mergeProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ClaimAccountStatement);

export default ClaimAccountStatementContainer;



// WEBPACK FOOTER //
// ./components/claim/ClaimAccountStatementContainer.js